import React, { useState, useRef, useEffect } from "react";

const SearchableDropdown = ({ label, options, selected, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter((opt) =>
    (opt?.name || opt)?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="mb-3" ref={dropdownRef}>
      <label className="form-label">{label}</label>&nbsp;{" "}
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary dropdown-toggle text-start"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selected
          ? options.find((opt) => (opt._id || opt) === selected)?.name || selected
          : placeholder}
      </button>

      {isOpen && (
        <div className="dropdown-menu show p-2" style={{ maxHeight: "250px", overflowY: "auto" }}>
          {/* Search Box */}
          <input
            type="text"
            placeholder="Search..."
            className="form-control mb-2"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />

          {/* Reset option */}
          <button
            className="dropdown-item"
            onClick={() => {
              onChange("");
              setIsOpen(false);
            }}
          >
            {placeholder}
          </button>

          {/* Options */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt) => (
              <button
                key={opt._id || opt}
                className="dropdown-item"
                onClick={() => {
                  onChange(opt._id || opt);
                  setIsOpen(false);
                }}
              >
                {opt.name || opt}
              </button>
            ))
          ) : (
            <p className="text-muted text-center">No results found</p>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchableDropdown;
